import * as t from "io-ts";

/** Shared message wire shapes. Enum strings stay open for forward compatibility. */
export const ObjectRefValidator = t.partial({
  objectType: t.string, objectId: t.string, database: t.string, regionId: t.string,
  resourceIdentifiers: t.array(t.string), fieldPath: t.array(t.string), occurredDttm: t.number,
  context: t.record(t.string, t.string), label: t.string,
});
export const MessageTokenValidator = t.partial({
  key: t.string, display: t.string, rawValue: t.string, type: t.string, role: t.string,
  tone: t.string, emphasis: t.array(t.string), unit: t.string, hint: t.string, link: ObjectRefValidator,
});
export const RichMessageValidator = t.partial({
  summary: t.string, detail: t.string, plainText: t.string,
  tokens: t.array(MessageTokenValidator),
  facts: t.array(t.partial({label: t.string, value: MessageTokenValidator})),
});
